import React from 'react';
import { CNavLink } from "../common/Header/c/CHeader";
import ExamSection from "./examSection";
import { useSubExamsList, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useSelector } from "react-redux";

/**
 * Exams board widget
 * This widget show list of exams and total quizzes and total attempted quizzes
 */
function ExamsBoard(props) {
    const t = useTranslations();
    //fetch data of sub exams
    const { subExamsQuizReport, subExamsQuizReportLoading } = useSubExamsList();
    const user = useSelector((state) => state.user);

    function renderLoading() {
        //we will show three cards to fill this space.
        return (
            <div className="exam-section">
            </div>
        );
    }

    function renderTests() {
        return (
            subExamsQuizReport && subExamsQuizReport.length ? subExamsQuizReport.map((exam, index) => {
                return (
                    <div key={index} className="exam-section">
                        <ExamSection examData={exam} t={t}/>
                    </div>
                );
            }) : 'No live test for this exam.'
        );
    }

    return (
        <>
            {
                (subExamsQuizReportLoading || subExamsQuizReport.length) > 0 && <div className="exam-board">
                    <div className="exam-board mock-test-strip">
                        <div className="exam-heading">
                            <h2>{user && user.selectedExam ? user.selectedExam.name : ''}</h2>
                            <CNavLink to="/my-app/tests">{t('view_all')}</CNavLink>

                        </div>
                        <div className="exam-section-container">
                            {!subExamsQuizReportLoading ? renderTests(subExamsQuizReport) : renderLoading()}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ExamsBoard;
